@if (selfLayout !== 'blank') {
  <div class="bv-app" [class.bv-app--sidebar-collapsed]="sidebarCollapsed">
    <app-aside class="bv-sidebar"></app-aside>
    <div class="bv-main">
      <app-navbar class="bv-topbar"></app-navbar>
      @if (canSeeIcalBanner) {
        <app-ical-onboarding-banner></app-ical-onboarding-banner>
      }
      <div class="bv-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
} @else {
  <div class="bv-app bv-app--blank">
    <router-outlet></router-outlet>
  </div>
}

<app-scripts-init></app-scripts-init>
